module.exports = __webpack_public_path__ + "img/communication.d110060a.svg";